import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { useDispatch } from "react-redux";
import { actionToAddToCart } from "../../../redux/action";
import useAuth from "../../../redux/hooks/useAuth";
import {formatImageTitle, formatPrice, getPriceAfterDiscount} from "../../../redux/utility/jwtUtils";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import RatingComponent from "./RatingComponent";
const ProductCard = ({ productItems }) => {
    const { auth } = useAuth();
    const dispatch = useDispatch();
    const [imageLoaded, setImageLoaded] = useState(false); // Track image loading status

    const addToCart = (e, productDetailData) => {
        e.preventDefault();
        e.stopPropagation();
        let products = { product_id: productDetailData.id, quantity: 1 };
        dispatch(actionToAddToCart(products, auth?.id));
        toast.success("Item added to cart!", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getPriceHtml = (productDetailData) => {
        const salePrice = getPriceAfterDiscount(productDetailData);
        if (salePrice !== productDetailData.sale_price) {
            return (
                <div className='flex flex-col'>
                    <div className="flex items-center gap-2 mt-1">
                        <span className="text-sm line-through opacity-50">
                            {formatPrice(productDetailData.sale_price)}
                        </span>
                        <span className="bg-green px-1.5 py-0.5 rounded-md text-xs text-white">
                            {productDetailData.message}
                        </span>
                    </div>
                    <span className="text-xl font-bold">
                       {formatPrice(salePrice)}
                    </span>
                </div>
            );
        } else {
            return (
                <div className='flex flex-col'>
                    <span>&nbsp;</span>
                    <span className="text-xl font-bold">
                       {formatPrice(salePrice)}
                    </span>
                </div>
            );
        }
    };

    return (
        <>
            {productItems.photo ? (
                <div className=''>
                    <Link to={'/products/' + productItems.slug}>
                        <div className='product mtop'>
                            <h3>{productItems.name}</h3>

                            <div className='img'>
                                {/* Image container with fixed dimensions to prevent layout shift */}
                                <div style={{ width: 'fit-content', height: 'fit-content', position: 'relative' }}>
                                    {/* Normal img with onLoad event */}
                                    <img
                                        src={productItems.photo}
                                        alt={formatImageTitle(productItems.name)+' - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                        title={formatImageTitle(productItems.name)+' - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                        onLoad={() => setImageLoaded(true)}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            display: imageLoaded ? 'block' : 'none'
                                        }}
                                    />
                                    {/* Placeholder while the image is loading */}
                                    {!imageLoaded && (
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: '#f0f0f0',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <span>Loading...</span>
                                        </div>
                                    )}
                                </div>

                                <div className='product-like'>
                                    <FontAwesomeIcon className='icon text-red' icon={faHeart} />
                                </div>
                            </div>

                            <div className=''>
                                <div className='rate'>
                                    {productItems.ratings > 0 ? <RatingComponent rating={productItems.ratings} /> : <span dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />}
                                </div>
                                <div className='price'>
                                    {getPriceHtml(productItems)}
                                    <button onClick={(e) => addToCart(e, productItems)} aria-label={'add product to cart'}>
                                        <FontAwesomeIcon icon={faShoppingCart} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            ) : null}
        </>
    );
};

export default ProductCard;
